@if (show()) {
  <div class="tw:absolute tw:inset-0 tw:bg-black tw:opacity-60"></div>

  <div class="tw:relative tw:flex tw:h-full tw:w-full tw:items-center tw:justify-center">
    <div
      class="tw:typography-labels-1 tw:flex tw:max-w-[230px] tw:flex-col tw:items-center tw:justify-center tw:gap-5 tw:text-center tw:text-white"
    >
      @if (allowedOrientation() === 'portrait') {
        <fr8bot-ui-icon name="rotate-phone-2" [size]="100" />
      } @else {
        <fr8bot-ui-icon name="rotate-phone" [size]="100" />
      }

      {{ 'common.rotateDevice.' + allowedOrientation() | translate }}
    </div>
  </div>
}
